import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableCustomerLocationPair = QueryHookResult<
  typeof useCustomerLocationPairQuery
>[number];

export const useCustomerLocationPairQuery = createQueryHook(
  'shared.selectCustomerLocationPair',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    accountAddresses: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          isCustomer: true,
          searchByAccountName: true,
        },
        pagination: {
          offset: 0,
          limit: 50,
        },
      },
      entries: {
        id: true,
        accountId: true,
        name: true,
        locationType: true,
        address: {
          streetAddress: true,
          city: true,
          state: true,
          postalCode: true,
          country: true,
        },
        account: {
          name: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.accountAddresses.entries ?? [],
  },
);

interface CustomerEntityProps {
  address: {
    streetAddress: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
  };
}

export const formatCustomerAddress = (entity: CustomerEntityProps): string => {
  const parts = [
    entity.address.streetAddress,
    entity.address.city,
    entity.address.state,
    entity.address.postalCode,
  ].filter(Boolean);

  return parts.join(', ') || 'No address';
};

export const SelectCustomerLocationPairTouch =
  createEntityTouchSelect.remotelySearched(
    'SelectCustomerLocationPair',
    useCustomerLocationPairQuery,
    {
      formatLabel: (entity) =>
        (entity.account?.name ?? 'Unknown') +
        (entity.name ? ' — ' + entity.name : ''),
      formatSubLabel: (entity) => formatCustomerAddress(entity),
    },
  );
